import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useHistory, useLocation } from 'react-router-dom';
import { useFlag } from '@unleash/proxy-client-react';

import NotificationTab from './topbar/notification-tab';
import Footer from './shared/Footer';
import { useAppContext } from '../context';
import { Flex } from './abstract';
import TopBar from './topbar';
import Header from './header';

const Container = styled.div`
  height: 100vh !important;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  grid-template-areas:
    'header'
    'main';
`;

const Main = styled.div`
  overflow-x: hidden;
  grid-area: main;
  min-height: calc(100% - 155px);
  ${({ scroll, footerInScroll }) =>
    footerInScroll
      ? `
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    grid-template-rows: unset;
  `
      : scroll
      ? `
    display: grid;
    overflow-y: auto;
    grid-template-rows: 1fr auto;
  `
      : `
    display: grid;
    overflow: hidden;
    grid-template-rows: 1fr;
  `}
  @media (max-width: 768px) {
    overflow-y: ${({ scroll, footerInScroll }) =>
      footerInScroll ? 'auto' : scroll ? 'auto' : 'hidden'};
  }
`;

const Navigation = styled.div`
  grid-area: header;
`;

export const Layout = ({
  children,
  header = true,
  footer = true,
  tabs = false,
  tabsData = {},
  user = false,
  scroll = true,
  footerInScroll = false,
  ...etc
}) => {
  const { isApp } = useAppContext();
  const history = useHistory();
  const location = useLocation();
  const enabledProximasDisputas = useFlag('leilao_proximas_disputas_enabled');

  const tabsItems = useMemo(
    function() {
      let items = [
        {
          label: 'novas ofertas',
          counter: tabsData?.newOffersCount,
          active: tabsData?.activeTab === 0,
          onClick: tabsData?.onClickTab0,
        },
        {
          label: 'participando',
          showNotifyIcon: tabsData?.showNotifyIcon,
          counter: tabsData?.participatingCount,
          active: tabsData?.activeTab === 1,
          onClick: tabsData?.onClickTab1,
        },
      ];
      if (enabledProximasDisputas) {
        items.push({
          label: 'próximas disputas',
          counter: tabsData?.upcomingDisputesCount,
          active: tabsData?.activeTab === 3,
          onClick: tabsData?.onClickTab3,
        });
      }
      if (user && !user.isNinja()) {
        items.push({
          label: <NotificationTab />,
          active: tabsData?.activeTab === 2,
          onClick: tabsData?.onClickTab2,
        });
      }
      return items;
    },
    [tabsData, user, enabledProximasDisputas]
  );

  const flexCss = footerInScroll
    ? {
        flex: '0 0 auto',
        height: 'calc(100vh - 155px)',
        minHeight: 'calc(100vh - 155px)',
        overflow: 'hidden',
        position: 'relative',
        maxWidth: '100vw',
      }
    : { flexGrow: 1, position: 'relative', maxWidth: '100vw' };

  return (
    <Container>
      <Navigation>
        {header && <Header />}
        {tabs && <TopBar tabs={tabsItems} />}
      </Navigation>
      <Main id="base-layout" scroll={scroll} footerInScroll={footerInScroll}>
        <Flex css={flexCss}>{children}</Flex>
        {!isApp && footer && scroll && !footerInScroll && <Footer />}
        {!isApp && footer && footerInScroll && <Footer />}
      </Main>
    </Container>
  );
};
